import clsx from "clsx";
import { memo } from "react";

import { Icon } from "@atoms/icon";
import { Typography } from "@atoms/typography";

import { IButtonSizeEnum } from "../button/types";

import classes from "./styles.module.scss";

import type { IButtonGroupProps } from "./types";

export const ButtonGroup = memo(function ButtonGroup({
  buttons,
  size = IButtonSizeEnum.Small,
  className,
}: IButtonGroupProps) {
  return (
    <div className={clsx(classes.allButtons)}>
      {buttons?.map(
        ({ key, startIcon, label, endIcon, disabled, ...rootAttribute }) => (
          <button
            key={key}
            data-size={size}
            className={clsx(classes.button, className)}
            disabled={disabled}
            type={"button"}
            {...rootAttribute}
          >
            <Typography
              fontType={"label-small"}
              themeColor={"inherit"}
              className={clsx(classes.button__container)}
            >
              {startIcon && <Icon name={startIcon} fontSize={"fs-20"} />}
              {label && <span className={"px-4"}>{label || undefined}</span>}
              {endIcon && <Icon name={endIcon} fontSize={"fs-20"} />}
            </Typography>
          </button>
        ),
      )}
    </div>
  );
});
ButtonGroup.displayName = "ButtonGroup";
